import { ToolImplementation, ToolResult, ToolSchema } from '../tool-types';

const DEFAULT_KEYWORDS_DURATION_MS = 0; // 0 = keep until audio ends

export const showKeywordsToolMetroSchema: ToolSchema = {
  type: 'function',
  name: 'show_keywords',
  description: 'Display 2 to 5 key concept words on screen as a visual emphasis for the user.',
  parameters: {
    type: 'object',
    properties: {
      keywords: {
        type: 'array',
        items: {
          type: 'string',
          description: 'A single keyword'
        },
        description: '2 to 5 keywords to display'
      },
      durationMs: {
        type: 'number',
        description: 'How long the keywords should be shown in milliseconds (default 6000)'
      }
    },
    required: ['keywords'],
    additionalProperties: false
  }
};

export const showKeywordsToolMetroImplementation: ToolImplementation = async (
  args: any
): Promise<ToolResult> => {
  try {
    const keywords = Array.isArray(args?.keywords)
      ? args.keywords
          .map((item: unknown) => (typeof item === 'string' ? item.trim() : ''))
          .filter(Boolean)
          .slice(0, 5)
      : [];

    if (keywords.length < 2) {
      return { success: false, error: 'Provide at least 2 keywords.' };
    }

    const durationMs =
      typeof args?.durationMs === 'number' && Number.isFinite(args.durationMs) && args.durationMs > 0
        ? args.durationMs
        : DEFAULT_KEYWORDS_DURATION_MS;

    if (typeof window !== 'undefined') {
      window.dispatchEvent(
        new CustomEvent('metro-show-keywords', {
          detail: { keywords, durationMs }
        })
      );
    }

    return {
      success: true,
      data: { keywordsCount: keywords.length, durationMs }
    };
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error while showing keywords'
    };
  }
};
